





























































































import Vue from 'vue';
import Icon from '../Icon';
import Outline from '../Outline';
import notranslate from '../notranslate';

export default Vue.extend({
  components: { Icon, Outline },
  directives: { notranslate },
  model: {
    prop: 'value',
    event: 'selected',
  },
  props: {
    value: {
      type: String,
      required: false,
    },
    options: {
      type: Array as Vue.PropType<string[]>,
      required: true,
    },
    // default false, e não true como na lib: lá o `required` nunca era repassado ao
    // Outline, então nenhum select jamais mostrou asterisco. Manter true e passar a
    // repassar faria aparecer asterisco em ~15 campos de uma vez. Quem quer o
    // asterisco passa explícito.
    required: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    withRadio: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.$props.value,
      isDisabled: this.disabled,
      isFocused: false,
      isHovering: false,
    };
  },
  methods: {
    hideDropdown() {
      this.isFocused = false;
    },
    toggleDropdown() {
      if (!this.isDisabled && !this.readonly) {
        this.isFocused = !this.isFocused;
      }
    },
    selectHandler(option: string) {
      this.selected = option;
      this.$emit('selected', option);
      this.hideDropdown();
    },
    hasContent(): Boolean {
      return Boolean(this.selected);
    },
    hoverHandler(hovering: boolean) {
      this.isHovering = hovering;
    },
  },
});
